import React from 'react';
import { observer } from 'mobx-react';
import moment from 'moment';
import {
    FlexDiv,
    SpaceBetweenDiv,
    StatusBadge,
    TextDefault,
    TextTiny,
    palette,
} from '@awarego-ui/components';

function RemindersEventPreview({
    events = [],
    timeZone,
    onToggleExclude,
    canToggle = false,
}) {
    if (!events.length) {
        return (
            <TextTiny lighter>
                No reminder events in this preview. Enable reminders and choose
                dates to see scheduled sends.
            </TextTiny>
        );
    }

    return (
        <FlexDiv column gap={8}>
            <TextDefault bold>Event preview</TextDefault>
            <TextTiny lighter>
                Sent reminders stay as they are. Skip a future date to leave it
                out of the schedule; you can include it again before Save.
            </TextTiny>
            <div
                style={{
                    maxHeight: 220,
                    overflow: 'auto',
                    border: `1px solid ${palette.graphite.cloud}`,
                    borderRadius: 8,
                }}
            >
                {events.map((event, i) => (
                    <SpaceBetweenDiv
                        key={`${event.status}-${event.send}-${i}`}
                        alignCenter
                        px={12}
                        py={8}
                        $noWrap
                        gap={12}
                        style={{
                            borderBottom:
                                i === events.length - 1
                                    ? 'none'
                                    : `1px solid ${palette.graphite.cloud}`,
                            opacity: event.skipped ? 0.55 : 1,
                        }}
                    >
                        {event.status > 0 ? (
                            <StatusBadge
                                color={palette.evergreen.aspargus}
                                text="Sent"
                            />
                        ) : event.skipped ? (
                            <StatusBadge
                                color={palette.graphite.ash}
                                text="Skipped"
                            />
                        ) : (
                            <StatusBadge
                                color={palette.vibrant.blue}
                                text="Scheduled"
                            />
                        )}
                        <TextTiny>
                            {event.send
                                ? moment(event.send).format(
                                      `ll LT [${timeZone || ''}]`
                                  )
                                : '-'}
                        </TextTiny>
                        {canToggle &&
                            event.status <= 0 &&
                            event.send &&
                            onToggleExclude && (
                                <TextDefault
                                    link
                                    themed
                                    bold
                                    onClick={() =>
                                        onToggleExclude(event.send)
                                    }
                                >
                                    {event.skipped ? 'Include' : 'Skip'}
                                </TextDefault>
                            )}
                    </SpaceBetweenDiv>
                ))}
            </div>
        </FlexDiv>
    );
}

export default observer(RemindersEventPreview);
